import React from 'react';

const layouts = () => {
    return (
        <iframe src="https://toeic.ames.edu.vn/tieng-anh-that-de/demo-cap-thieu-nien" style={{ width: '100%', height: '99vh', border: 'none'}} title="Olympic Tiếng Anh"></iframe>
    );
}

export default layouts;
